import {AdvertApiResponse, ApiResponse} from "../types/ApiResponse";
import {deserialize} from "deserialize-json-api";
import {Advert} from "../types/Advert";
import {RequestParams} from "./RequestParams";
import {Make} from "../types/Make";
import {Location} from "../types/Location";

const token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxMCIsImp0aSI6IjIyYzc3YWRhM2VjNDUxYWYxYWU3OWU1NTk5YzAyMGU4MGI0ZWE0Nzk3YzEwNjkyYTkyNmYwOTgwZjA2MjAwMjA2MmJjZDc1OGE0MjY0MzhmIiwiaWF0IjoxNzEyODIzNjg5LjgwNDI4LCJuYmYiOjE3MTI4MjM2ODkuODA0MjgzLCJleHAiOjE3NDQzNTk2ODkuODAxMzkzLCJzdWIiOiIiLCJzY29wZXMiOltdfQ.KLbx7xL5k2_uXC6uhCoQneCIA8nH7P4o7txw3PwuocJ1bpt3YkH90Kuo5lHIHl3lLGo4cCX1e-Mold4Ol47buvka1ZP49CTZ_AiphblHrwMaHf7lzQamh-KXzfdrSbY6iHG5I0bVvFCwm0s_ud0axLXGOvqi-XE8mT5pQeki04zkR29uFJltTbVLI4r_dlAIrdFHr91LRrivtD37t4pOx1t2-fskRzZ6zo-otpKbeLTwX2OJMhzJ3slwN0P7XMmPn7UbCktChrdOajbvhNT68_e-5OEJA5g0g2d1cNHxgo6TccQgoKFt4SpcA4TzUwhqRwhBIlqoV7mR8UDYxzlfQTMbVidZIuXDaEIEUyVofYH5sj1vf3kGp0B3Ixr2iN068Ds2ax0venETze1-lKkKjPJa4Hz9vdNxsZevMLhSGCBVJhSF8_53DTj4HXWxF8qXOEzDaAEloyn7yoDok_hjtNo_-ZG80PDezSPm0nsrELBrEbbt8w8YU1BxUFPamcSnOa0I_f8CDoulntO4uMTc0KmHMsldJS94X1olaZON9b00AKT9nVicxLykECURNclCHtzLlJHWEt-clAHqGr5B1AYRHdZ1ln0wEyYbykoFjdrEpbIorbeyUqn2ADRO1lfzsvisLRh812VAQgUTGEYCtM74CKzgeHj6PJuTRw2brg8";
const API_URL = "https://choosemycar.com/api";

const apiRequest = async (endpoint: string, method: string = "GET") => {
    return await fetch(`${API_URL}${endpoint}`, {
        method: method,
        headers: {
            "Accept": "application/vnd.api+json",
            "Content-Type": "application/vnd.api+json",
            "Authorization": "Bearer " + token,
        }
    });
}

export async function fetchAdverts(params: RequestParams): Promise<AdvertApiResponse<Advert>> {
    const res = await apiRequest(`/adverts/search${params.toApiString()}`)
    return deserialize(await res.json());
}

export async function fetchMakes(): Promise<ApiResponse<Make>> {
    const res = await apiRequest(`/makes?filter[standard]=true`);
    return deserialize(await res.json());
}

export async function fetchLocations(): Promise<ApiResponse<Location>> {
    const res = await apiRequest(`/locations`);
    return deserialize(await res.json());
}
